'use client';

import React from 'react';
import { RegFormField } from '@/features/b2b/register/components/RegFormField';

export const ManualCompanyDetailsForm = ({ formData, handleInputChange, errors }) => {
  if (formData.fcaData !== '0') {
    return null;
  }

  return (
    <div>
      <RegFormField
        label="Company name"
        name="name2"
        value={formData.name2}
        onChange={handleInputChange}
        placeholder="Example LTD"
        required={formData.fcaData === '0'}
        error={errors.name2}
      />

      <RegFormField
        label="Company phone number"
        name="phone2"
        type="tel"
        value={formData.phone2}
        onChange={handleInputChange}
        placeholder="07803 675 543"
        error={errors.phone2}
      />

      <RegFormField
        label="Address line 1"
        name="al12"
        value={formData.al12}
        onChange={handleInputChange}
        placeholder="123 Main Street"
        error={errors.al12}
      />

      <RegFormField
        label="Address line 2"
        name="al22"
        value={formData.al22}
        onChange={handleInputChange}
        placeholder="Suite 456"
      />

      <RegFormField
        label="Town/City"
        name="town2"
        value={formData.town2}
        onChange={handleInputChange}
        placeholder="London"
        error={errors.town2}
      />

      <div className="md:flex md:gap-2">
        <div>
          <RegFormField
            label="County (If applicable)"
            name="county2"
            value={formData.county2}
            onChange={handleInputChange}
            placeholder="Westminster"
          />
        </div>

        <div>
          <RegFormField
            label="Postcode"
            name="postcode2"
            value={formData.postcode2}
            onChange={handleInputChange}
            placeholder="SW1A 1AA"
            error={errors.postcode2}
          />
        </div>
      </div>
    </div>
  );
};
